import ChallengesTable from "./ChallengesTable";

export default ChallengesTable;
